export default __webpack_public_path__ + "static/media/memoryLogo.c632546c.png";